import React, { useState, useEffect, useRef } from 'react';
import { FadeIn } from './Animations';

const stats = [
  { number: 500, suffix: '+', label: 'Lives Transformed', icon: '✨' },
  { number: 4, suffix: '', label: 'Business Ventures', icon: '🚀' },
  { number: 10, suffix: '+', label: 'Years Experience', icon: '🏆' },
  { number: 1000, suffix: '+', label: 'Community Members', icon: '🤝' },
];

function CountUp({ target, suffix, duration = 2000 }) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setStarted(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return;
    let start = 0;
    const step = Math.ceil(target / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, [started, target, duration]);

  return <span ref={ref}>{count.toLocaleString()}{suffix}</span>;
}

export default function Stats() {
  return (
    <section style={{
      background: 'linear-gradient(135deg, #1A5C38 0%, #1E8449 60%, #27AE60 100%)',
      padding: 'clamp(40px, 6vw, 60px) clamp(20px, 4vw, 52px)',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', top: '-40px', right: '-40px',
        width: '200px', height: '200px', borderRadius: '50%',
        background: 'rgba(255,255,255,0.05)',
      }} />
      <div style={{
        position: 'absolute', bottom: '-60px', left: '-20px',
        width: '180px', height: '180px', borderRadius: '50%',
        background: 'rgba(201,151,58,0.1)',
      }} />
      <FadeIn>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
          gap: '24px',
          maxWidth: '1160px',
          margin: '0 auto',
          textAlign: 'center',
          position: 'relative', zIndex: 1,
        }}>
          {stats.map((s, i) => (
            <div key={s.label} style={{
              background: 'rgba(255,255,255,0.08)',
              borderRadius: '16px',
              padding: '24px 16px',
              border: '1px solid rgba(255,255,255,0.12)',
              backdropFilter: 'blur(10px)',
              transition: 'transform 0.3s, background 0.3s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.background = 'rgba(255,255,255,0.14)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
            }}
            >
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>{s.icon}</div>
              <div style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: 'clamp(28px, 4vw, 42px)',
                fontWeight: 900, color: '#fff', lineHeight: 1,
                marginBottom: '8px',
              }}>
                <CountUp target={s.number} suffix={s.suffix} />
              </div>
              <div style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '11px', fontWeight: 600,
                letterSpacing: '1.5px', textTransform: 'uppercase',
                color: 'rgba(255,255,255,0.75)',
              }}>{s.label}</div>
            </div>
          ))}
        </div>
      </FadeIn>
    </section>
  );
}
